import React from 'react'
import Button2 from '../../Buttons/Button2/Button2'
import AboutCompImage from '../../../assets/images/websites.webp';
import AnimateOnScroll from '../../ScrollAnimations/AnimateOnScroll';


const AboutComponent = () => {
    return (
        <div className='inner-about'>
            <div>
                <img className='AboutCompImage' src={AboutCompImage} alt="" srcSet='' />
            </div>
            <div>
                <AnimateOnScroll animationclassName="slide-in-right">

                    <span className='text-left-line'>About Us</span>

                    <p className="base_heading_2">
                        Professional Web Development Agency to Provide Solutions
                    </p>

                    <p className='base_p_tag'>Established with a vision to redefine the art of storytelling & design, we have been at the forefront of delivering groundbreaking creative solutions since our inception. Our agency is a dynamic powerhouse of talent, merging artistic flair with strategic acumen to bring visions to life.</p>

                    <div className="ul_div">

                        <div>
                            <ul>
                                <li className='base_p_tag'>Professional Problem Solutions</li>
                                <li className='base_p_tag'>Customer Relationship Management</li>
                                <li className='base_p_tag'>Web Design & Development</li>
                            </ul>
                        </div>

                        <div>
                            <ul>
                                <li className='base_p_tag'>Business Development</li>
                                <li className='base_p_tag'>Content Creation & Brand Strategy</li>
                                <li className='base_p_tag'>Digital Creative Agency</li>
                            </ul>
                        </div>
                    </div>


                    <Button2 text="Learn more" link="/about" />
                </AnimateOnScroll>

            </div>

        </div>
    )
}

export default AboutComponent